enum FontWeightEnum {
    Regular = 'regular-font-weight',
    Medium = 'medium-font-weight',
    Semibold = 'semibold-font-weight',
    Bold = 'bold-font-weight',
}

export default FontWeightEnum
